import { apiClient } from './api-client'
import { API_ENDPOINTS } from '@/config/constants'
import { Kpi, KpiEvaluationResult, EvaluateKpiDto } from '@/types'

export const kpisService = {
  getAll: async (): Promise<Kpi[]> => {
    return apiClient.get<Kpi[]>(API_ENDPOINTS.KPIS.BASE)
  },

  getById: async (id: string): Promise<Kpi> => {
    return apiClient.get<Kpi>(API_ENDPOINTS.KPIS.BY_ID(id))
  },

  evaluate: async (id: string, evaluateKpiDto?: EvaluateKpiDto): Promise<KpiEvaluationResult[]> => {
    return apiClient.post<KpiEvaluationResult[]>(API_ENDPOINTS.KPIS.EVALUATE(id), evaluateKpiDto || {})
  },
}

